import type { V2Persona } from "../../../common/types.ts";

/**
 * Sentinel id used for the in-progress custom persona on the client. The
 * server also rejects a real persona folder with this id (see
 * `resolvePresetPersonaImage` in apps/legacy/server/src/common/v2/personas.ts).
 */
export const CUSTOM_PERSONA_ID = "__custom__" as const;

export type CustomVoice =
	| { kind: "preset"; voiceId: string }
	| { kind: "clone"; sampleBase64: string };

export type DraftCustomPersona = {
	isCustom: true;
	id: typeof CUSTOM_PERSONA_ID;
	label: string;
	name: string;
	personality: string;
	voice: CustomVoice;
	/** Optional base64 data URL — image/png, image/jpeg, image/webp. */
	imageBase64?: string;
};

export type SelectedPersona =
	| { kind: "preset"; persona: V2Persona }
	| { kind: "custom"; draft: DraftCustomPersona };
